/* LUVEA — ACCUEIL RIDEAU (V20).
   Effet rideau vertical entre panneaux (meme mecanique que l'Atelier :
   sticky + rAF, pas de transitions CSS sur transform/opacity = pas de
   scintillement iPhone) + indicateurs du defilement horizontal.
   Le header transparent est deja gere par lv-hero-clear sur l'index. */
(function () {
  var hero = document.querySelector('.lv-ac-hero');
  if (!hero || hero.dataset.lvBound) { return; }
  hero.dataset.lvBound = '1';
  var slides = Array.prototype.slice.call(hero.querySelectorAll('.lv-ac-slide'));
  if (!slides.length) { return; }

  /* indicateurs horizontaux */
  slides.forEach(function (s) {
    var sc = s.querySelector('.hsc');
    var dots = s.querySelector('.dots');
    if (!sc || !dots) { return; }
    sc.addEventListener('scroll', function () {
      var i = Math.round(sc.scrollLeft / sc.clientWidth);
      dots.querySelectorAll('i').forEach(function (t, x) { t.classList.toggle('on', x === i); });
    }, { passive: true });
  });

  /* entree en fondu du premier panneau */
  setTimeout(function () {
    if (slides[0]) {
      slides[0].querySelectorAll('.blk').forEach(function (b) { b.classList.add('vis'); });
      var d0 = slides[0].querySelector('.dots'); if (d0) { d0.classList.add('vis'); }
    }
  }, 150);

  var rafId = 0;
  var calc = function () {
    rafId = 0;
    if (!document.body.contains(hero)) { window.removeEventListener('scroll', surScroll); return; }
    var r = hero.getBoundingClientRect();
    var h = slides[0].offsetHeight || 1;
    var pt = Math.min(slides.length - 1, Math.max(0, -r.top / h));
    slides.forEach(function (s, i) {
      if (i < slides.length - 1) {
        var p = Math.min(1, Math.max(0, pt - i));
        s.querySelectorAll('.hsl img, .hsl video').forEach(function (im) {
          im.style.transform = 'translateZ(0) scale(' + (1 + p * 0.06).toFixed(4) + ')';
        });
        var sh = s.querySelector('.sh');
        if (sh) { sh.style.opacity = (p * 0.45).toFixed(3); }
      }
      var vis = pt > i - 0.75 && pt < i + 0.22;
      s.querySelectorAll('.blk').forEach(function (b) { b.classList.toggle('vis', vis); });
      var dd = s.querySelector('.dots');
      if (dd) { dd.classList.toggle('vis', vis); }
    });
  };
  var surScroll = function () { if (!rafId) { rafId = requestAnimationFrame(calc); } };
  window.addEventListener('scroll', surScroll, { passive: true });
  surScroll();
})();
